import { avatars } from "@/assets/avatars";

const testimonialsAr = [
    {
      quote: "نيكسوس للجودة غيّر طريقة اختبارنا تمامًا. خبراؤهم قدّموا نتائج مذهلة ساعدتنا على الإطلاق بثقة.",
      name: "سارة تشن ",
      title: "المديرة التقنية، تك إنوفيت ",
      type: "client",
      avatar: avatars["aya"]
    },
    {
      quote: "مجتمع نيكسوس للجودة كان له دور كبير في تطوري كمهندسة جودة. الإرشاد والتحديات ساعدوني على تطوير مهاراتي. ",
      name: "ماركوس جونسون ",
      title: "مهندس ضمان الجودة الأول ",
      type: "community",
      avatar: ""
    },
    {
      quote: "قللنا معدل تسرب الأخطاء بنسبة 78٪ بعد تنفيذ استراتيجية الاختبار التي صممتها نيكسوس للجودة. نهجهم للجودة ثوري.",
      name: "جينيفر لي ",
      title: "نائبة رئيس قسم الهندسة، داتا فلو سيستمز ",
      type: "client",
      avatar: avatars["aya"]
    },
    {
      quote: "نظام الشهادات والشارات شجعني على توسيع معرفتي بالاختبار. اكتسبت مهارات وربطت علاقات سرّعت من مسيرتي المهنية.",
      name: "راج باتيل ",
      title: "أخصائي أتمتة ",
      type: "community",
      avatar: avatars["aya"]
    },
    {
      quote: "العمل مع نيكسوس للجودة أحدث فرقًا كبيرًا لفريق التطوير لدينا. أصبحنا نكشف المشكلات الحرجة في وقت مبكر.",
      name: "مايكل توريس ",
      title: "قائد التطوير، كلاود تك ",
      type: "client",
      avatar: avatars["aya"]
    },
    {
      quote: "ورش العمل والتدريب التي قدمتها نيكسوس للجودة حسّنت بشكل كبير قدرة فريقنا على كتابة كود قابل للاختبار.",
      name: "عائشة رحمن ",
      title: "مديرة ضمان الجودة ",
      type: "community",
      avatar: avatars["aya"]
    }
];
  
export default testimonialsAr;
  